import { call, put } from 'redux-saga/effects'
import { getData as apiGetData } from 'api/Api'
import {
  setLayouts as setLayoutsInView
} from '../redux/view'
import {
  addArray as addLayoutArray
} from '../redux/layouts'

export default function * fetchMyHomeLayouts () {
  const { Layouts } = yield call(apiGetData, 'MyHomeLayouts')

  const batchedActions = []
  const layouts = []

  batchedActions.push(addLayoutArray(Layouts.map(Layout => {
    layouts.push(Layout.Id)

    return {
      id: Layout.Id,
      name: Layout.Name,
      description: Layout.Description,
      isPublic: Layout.IsPublic,
      isShared: Layout.IsShared,
      isTemplate: Layout.IsTemplate,
      isLocked: Layout.IsLocked,
      position: Layout.Position
    }
  })))

  batchedActions.push(setLayoutsInView({ layouts }))

  yield put(batchedActions)
}
